export class InventoryTypeFieldValueMessage {
  id: number
  inventoryTypeFieldId: number
  value: string

  constructor(id: number, inventoryTypeFieldId: number, value: string) {
    this.id = id
    this.inventoryTypeFieldId = inventoryTypeFieldId
    this.value = value
  }
}
  